export const doclabelMap = {
    "registration_certificate": "Club/institute",
    "tax_identification": "GST/80G Certificate/10AC Certificate",
    "affiliation": "Affiliation Certificate",
    "registration_certificate": "Club/institute",
    "tax_identification": "GST/80G Certificate/10AC Certificate",
    "Affiliation": "Affiliation Certificate",
    "facility_owner": "Facility Ownership Proof",
    "facility_safety": "Facility Safety Compliance Certificate",
    "achievements": "Certificates of major titles/awards",
    "financial_bank": "Bank Passbook (Front Page Upload)",
    "financial_Recent": "Recent financial statements",
    "identity_Proof": "Owner/Coach",
    "profile_image":"Institution Logo"
    
  };